module.exports = __webpack_public_path__ + "img/withdraw3.662d2a10.jpg";